// extracted by mini-css-extract-plugin
module.exports = {"Section":"LocationAndYearSection-style__Section--2Jox6"};